import * as React from "react";

import { cn } from "../../utils/utils";

export interface InputProps
	extends React.InputHTMLAttributes<HTMLInputElement> { }

const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, type, onWheel, ...props }, ref) => {
		return (
			<input
				type={type}
				className={cn(
					"flex h-10 w-full font-semibold  rounded-xl border-[1px] border-border bg-bginput px-3 py-2 text-sm  file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none  disabled:cursor-not-allowed disabled:opacity-50",
					className,
				)}
				ref={ref}
				onWheel={type === "number" ? (e) => { e.currentTarget.blur(); onWheel?.(e); } : onWheel}
				{...props}
			/>
		);
	},
);
Input.displayName = "Input";

export { Input };
